<p>task-summary-dialog works!</p>
